import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import Smartlook from 'smartlook-client';

type LogginDataType = {
  bump_screen: string[];
};

@Injectable({
  providedIn: 'root',
})
export class SmartlookService {
  private url = 'https://frontend-artifacts.prod.ap-southeast-2.hungrycoder.net/ready_to_serve/bumpscreen_logging.json';
  private smartlookKey = '9f85a1ee25610d2c49055edcc884d72893dacfb0';
  private logggingData: LogginDataType;
  private hasLoaded = false;

  constructor(private http: HttpClient) {}

  public startRecording = async (bumpScreenId: string) => {
    this.http.get(this.url).subscribe(res => {
      this.logggingData = res as LogginDataType;

      // test account
      this.logggingData.bump_screen.push('48549408'); // Sandbar

      const isRecordable = this.logggingData.bump_screen.includes(bumpScreenId);

      if (isRecordable && !this.hasLoaded) {
        const params = {
          advancedNetwork: {
            allowedUrls: ['https://admin.dev.ap-southeast-2.hungrycoder.net/api/bump/orders/list/v2/' + bumpScreenId],
          },
        };

        try {
          Smartlook.init(this.smartlookKey, params);
          Smartlook.record({
            emails: true,
            forms: true,
            numbers: true,
            ips: true,
          });
        } catch (error) {
          console.error('Error starting Smartlook', error);
        }

        this.hasLoaded = true;
      }
    });
  };
}
